import React, { useState } from 'react';
import { OverlayContainer } from '@react-aria/overlays';

import { Modal, RadioGroup, RadioOption, TextField, Typography } from '@riac/design-system';

import { IMapping } from 'src/pages/CatalogPage/Catalog.i';
import { TFacet } from 'src/pages/CatalogPage/CatalogPage.i';


interface IManuModal {
  changeFilter(slug: string, field: string): void;
  close(): void;
  manuMappings: IMapping[];
  manu: string;
  facets: TFacet;
}

export const ManuFilterModal = (props: IManuModal) => {
  const [searchInput, setSearchInput] = useState('');
  const [sortAlpha, setSortAlpha] = useState(true);

  function handleInput(val) {
    setSearchInput(val);
  }

  function closeModal() {
    props.close();
  }

  function clearSearch() {
    setSearchInput('');
  }

  if(props.manuMappings.length === 0) {
    return null;
  }
  const manuFilteredList = Object.keys(props.facets).filter((manu) =>
    manu.toLowerCase().trim().includes(searchInput.toLowerCase().trim())
  );

  return (
    <OverlayContainer>
      <Modal
        isOpen
        onClose={closeModal}
        title='Filter By Manufacturer'
        fullHeight
        type='basic'
        showCloseButton
      >
        <div className='max-h-full flex flex-col gap-2'>
          <div className='flex'>
            <RadioGroup
              name='sort_manu'
              value={sortAlpha ? 'true' : 'false'}
              onChange={(val) => setSortAlpha(val === 'true')}
            >
              <RadioOption value={'true'}>Sort alphanumerically</RadioOption>
              <RadioOption value={'false'}>Sort by most popular</RadioOption>
            </RadioGroup>
          </div>
          <TextField
            type='text'
            placeholder='Filter Results'
            aria-label='Filter Results'
            value={searchInput}
            onChange={handleInput}
            hasReset
            onReset={clearSearch}
          />
          <div className='flex-1 overflow-y-auto overflow-x-hidden -mx-4 px-4'>
            <RadioGroup
              name='manu'
              value={props.manu}
              onChange={(e) => {
                props.manuMappings.find((x) => x.slug)
                props.changeFilter(e, 'manu');
                closeModal();
              }}
            >
              <div className='grid grid-cols-1 lg:grid-cols-3 xl:grid-cols-4 gap-3'>
                {manuFilteredList
                  .filter((manu) => props.facets[manu.trim()] > 0)
                  .sort(
                    sortAlpha
                      ? (a, b) => {
                        return a.localeCompare(b);
                      }
                      : (a, b) => {
                        return props.facets[b] - props.facets[a];
                      }
                  )
                  .slice()
                  .map((manu) => {
                    const manufacturer = props.manuMappings.filter(
                      (mapping) => mapping.value.trim() === manu.trim()
                    )[0];
                    if(!manufacturer) {
                      return null;
                    }
                    const count = props.facets[manufacturer.value.trim()] || 0;
                    if(count > 0) {
                      return (
                        <div key={manufacturer.value} className='flex items-stretch justify-stretch'>
                          <RadioOption
                            value={manufacturer.slug}
                          >
                            {manufacturer.name}&nbsp;<Typography size='xs' weight='medium' color='text-lighter' className='inline'>({count})</Typography>
                          </RadioOption>
                        </div>
                      );
                    }
                  })
                }
              </div>
            </RadioGroup>
          </div>
        </div>
      </Modal>
    </OverlayContainer>
  );
};
